import { DefaultTheme } from 'styled-components'

import { darkThemeColors, lightThemeColors } from './colors'
import { typography } from './typography'
import { breakpoints } from './breakpoints'
import { settings } from './settings'

export const theme: DefaultTheme = {
  colors: lightThemeColors,
  typography,
  breakpoints,
  settings,
}

export const darkTheme: DefaultTheme = {
  colors: darkThemeColors,
  typography,
  breakpoints,
  settings,
}

declare module 'styled-components' {
  export interface DefaultTheme {
    colors: typeof darkThemeColors
    typography: typeof typography
    breakpoints: typeof breakpoints
    settings: typeof settings
  }
}
